var doc = document.documentElement;
doc.setAttribute('data-useragent', navigator.userAgent);


$(document).ready(function(){

//	Greenbox plugins

//	Custom event listeners
//	$.fn.esEventResizeend();										// set resizeend listener
//	$.fn.esEventScroll();											// set scrollend listener

	$.fn.esSwitch();
	$.fn.esToggle();
	$.fn.esPaginate();

	//$.fn.esFluidHeight();
	//$.fn.esSetWindowsHeight();

//	UI modifiers
	// adds tab functionality
	$.fn.esTab({
		event: {
			afterSelect: function () {
				$(".richtext iframe, .portlet-html iframe, .entry-remoteurl iframe, .entry-iframe iframe").responsiveEmbed();
			}
		}
	});

	$(".panel-group.accordion").panelAccordion({					// accordion for panels
		set: {
			hashAutoExpand: true,
			autoCollapse: false
		}
	});

//	Image handlers
	$.fn.esResponsiveImg();											// convers item to img with bg
//	$.fn.esImgCrop();												// data-es-crop értékét átírja ba-align-… classként
//	$.fn.preloader();												// preloader mainly for images

//	Form plugins
	$.fn.esSelectBtn();												// convert select to button
//	$.fn.esSelectDir();												// conver select to direction selector
//	$.fn.datePicker();												// datepicker
//	$.fn.autoComplete();											// autocomplete
//	$.fn.esInputReset												// input reset
//	$.fn.esInputChar												//


//	portlet specific plugins
	$.fn.esPortletTab();											// convert portlets to tabbed portlet

	$.fn.esAjaxSource();
	$.fn.esAjaxTarget();											// AC

//	$.fn.esStickyHeader();
//	$.fn.esValignMiddle();
//	$.fn.isVisible();

//	$("[data-es-link]").esLink();
//	$.fn.esSliderPro();

	//$.fn.esDesignMode({ grid: { columns: 12 } });					//	launch design mode listener
	//$(".main-footer").esStickyFooter({ class: "sticky-footer" });	//	set sticky footer
	$(".fancybox-thumb").fancybox();								//	launch fancybox


//	if device supports touch
//	if (Modernizr.touch) { $("html").addClass("touch"); } else { $("html").addClass("no-touch"); }

	$(".richtext iframe, .portlet-html iframe, .entry-remoteurl iframe, .entry-iframe iframe").responsiveEmbed();

	//	makes fb comment responsive
	$(window).on("load resizeend", function(){
		if (typeof FB === 'undefined') {return;}
		$(".fb-comments").attr("data-width", $(".fb-comments").width());
		FB.XFBML.parse($(".comments")[0]);
	});

	siteCode.mainmenuJumpToHash();
	//siteCode.hightlightAnim();

	$(window).on("scroll", function () {
		var fromTop = $(window).scrollTop(),
			header = $(".main-header");
		if (0 < fromTop) {
			header.addClass("inscroll");
		} else {
			header.removeClass("inscroll");
		}
	});
});

$(document).on("ready ajaxComplete", function() {
	//$.fn.esResponsiveImg();											// convers item to img with bg
});

